import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

export const showOverlay = (isLoading) => (
  <Backdrop sx={backdrop} open={isLoading}>
    <CircularProgress sx={{ color: 'white' }} />
  </Backdrop>
);

const backdrop = {
  background: 'rgba(18, 18, 18, 0.5)',
  zIndex: 100,
  position: 'absolute',
  width: '100vw',
};
